import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
const api = axios.create({ baseURL: `${BASE}/api` });

export function getSessionId() {
  let sid = localStorage.getItem("wispr_sid");
  if (!sid) return null;
  return sid;
}
export function setSessionId(sid) {
  localStorage.setItem("wispr_sid", sid);
}

export const API = {
  config: () => api.get("/config").then((r) => r.data),
  heuristics: () => api.get("/heuristics").then((r) => r.data),
  schemas: () => api.get("/schemas").then((r) => r.data),
  strategies: () => api.get("/strategies").then((r) => r.data),
  createSession: () => api.post("/sessions").then((r) => r.data),
  reset: (sid) => api.post(`/sessions/${sid}/reset`).then((r) => r.data),
  enrich: (sid, text, strategy_id, profile_id, meta = {}) =>
    api.post(`/sessions/${sid}/enrich`, { text, strategy_id, profile_id, ...meta }).then((r) => r.data),
  memories: (sid) => api.get(`/sessions/${sid}/memories`).then((r) => r.data.memories),
  createMemory: (sid, m) => api.post(`/sessions/${sid}/memories`, m).then((r) => r.data),
  updateMemory: (sid, mid, m) => api.put(`/sessions/${sid}/memories/${mid}`, m).then((r) => r.data),
  deleteMemory: (sid, mid) => api.delete(`/sessions/${sid}/memories/${mid}`).then((r) => r.data),
  importMemories: (sid, body) => api.post(`/sessions/${sid}/memories/import`, body).then((r) => r.data),
  clusters: (sid) => api.get(`/sessions/${sid}/clusters`).then((r) => r.data.clusters),
  createCluster: (sid, c) => api.post(`/sessions/${sid}/clusters`, c).then((r) => r.data),
  deleteCluster: (sid, cid) => api.delete(`/sessions/${sid}/clusters/${cid}`).then((r) => r.data),
  bindings: (sid) => api.get(`/sessions/${sid}/bindings`).then((r) => r.data.bindings),
  createBinding: (sid, b) => api.post(`/sessions/${sid}/bindings`, b).then((r) => r.data),
  deleteBinding: (sid, bid) => api.delete(`/sessions/${sid}/bindings/${bid}`).then((r) => r.data),
  feedback: (fb) => api.post("/feedback", fb).then((r) => r.data),
  suggestNote: (sid, text) => api.post(`/sessions/${sid}/suggest-note`, { text }).then((r) => r.data),
  contextPack: (sid, text, strategy_id, profile_id) =>
    api.post(`/sessions/${sid}/export/context-pack`, { text, strategy_id, profile_id }).then((r) => r.data),
  emailRequestCode: (sid, email) =>
    api.post(`/sessions/${sid}/email/request-code`, { email }).then((r) => r.data),
  emailVerify: (sid, email, code) =>
    api.post(`/sessions/${sid}/email/verify`, { email, code }).then((r) => r.data),
  emailSendPack: (sid, email, text, strategy_id, profile_id) =>
    api.post(`/sessions/${sid}/email/send-context-pack`, { email, text, strategy_id, profile_id }).then((r) => r.data),
};
